"use strict";

var _classCallCheck = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/zeit/4f42873e/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _webgltextureLoader = require("webgltexture-loader");

function loadImage(src, success, failure) {
  var img = new window.Image();

  if (src.slice(0, 5) !== "data:") {
    img.crossOrigin = true;
  }

  img.onload = function () {
    if (img) {
      success(img);
    }

    img = null;
  };

  img.onabort = img.onerror = failure;
  img.src = src;
  return function () {
    if (img) {
      img.onload = null;
      img.onerror = null;
      img.onabort = null;
      img.src = "";
      img = null;
    }
  };
}

var ImageURLTextureLoader =
/*#__PURE__*/
function (_webgltextureLoader$W) {
  _inherits(ImageURLTextureLoader, _webgltextureLoader$W);

  function ImageURLTextureLoader() {
    _classCallCheck(this, ImageURLTextureLoader);

    return _possibleConstructorReturn(this, _getPrototypeOf(ImageURLTextureLoader).apply(this, arguments));
  }

  _createClass(ImageURLTextureLoader, [{
    key: "canLoad",
    value: function canLoad(input) {
      return typeof input === "string";
    }
  }, {
    key: "inputHash",
    value: function inputHash(input) {
      return input;
    }
  }, {
    key: "loadNoCache",
    value: function loadNoCache(src) {
      var gl = this.gl;

      var _dispose;

      var promise = new Promise(function (success, failure) {
        return _dispose = loadImage(src, success, failure);
      }).then(function (img) {
        var width = img.width,
            height = img.height;
        var texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
        return {
          texture: texture,
          width: width,
          height: height
        };
      });
      return {
        promise: promise,
        dispose: function dispose() {
          return _dispose();
        }
      };
    }
  }]);

  return ImageURLTextureLoader;
}(_webgltextureLoader.WebGLTextureLoaderAsyncHashCache);

_webgltextureLoader.globalRegistry.add(ImageURLTextureLoader);

var _default = ImageURLTextureLoader;
exports.default = _default;